import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";

interface ImageLightboxProps {
  images: string[];
  open: boolean;
  index: number;
  onClose: () => void;
  onIndexChange?: (index: number) => void;
  darkMode?: boolean;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({
  images,
  open,
  index,
  onClose,
  onIndexChange,
  darkMode,
}) => {
  const slides = images.map((src) => ({ src }));

  return (
    <Lightbox
      open={open}
      index={index}
      close={onClose}
      slides={slides}
      plugins={[Zoom, Thumbnails, Counter]}
      on={{
        view: ({ index: newIndex }) => {
          if (onIndexChange) onIndexChange(newIndex);
        },
      }}
      carousel={{ finite: false, preload: 2 }}
      zoom={{
        maxZoomPixelRatio: 4,
        zoomInMultiplier: 2,
        doubleTapDelay: 300,
        doubleClickDelay: 300,
        doubleClickMaxStops: 2,
        keyboardMoveDistance: 50,
        wheelZoomDistanceFactor: 100,
        pinchZoomDistanceFactor: 100,
        scrollToZoom: true,
      }}
      thumbnails={{
        position: "bottom",
        width: 96,
        height: 64,
        border: 1,
        borderRadius: 6,
        padding: 4,
        gap: 8,
      }}
      counter={{ container: { style: { top: 16, left: 16, bottom: "unset" } } }}
      styles={{
        container: {
          backgroundColor: darkMode ? "rgba(0, 0, 0, 0.95)" : "rgba(20, 20, 20, 0.92)",
        },
        thumbnailsContainer: {
          backgroundColor: darkMode ? "rgba(0, 0, 0, 0.8)" : "rgba(20, 20, 20, 0.8)",
        },
      }}
      animation={{ fade: 250, swipe: 250 }}
      controller={{ closeOnBackdropClick: true }}
    />
  );
};

export default ImageLightbox;
